import { render, staticRenderFns } from "./Tweennum.vue?vue&type=template&id=0d0b6806&"
import script from "./Tweennum.vue?vue&type=script&lang=js&"
export * from "./Tweennum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_css-loader@6.7.1_vue-template-compiler@2.7.4_webpack@5.73.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports